/**
 * Google Analytics 4 via Firebase Analytics — consent-gated.
 *
 * Wird nur aktiviert, wenn der Nutzer explizit zugestimmt hat.
 * Nutzt die bereits initialisierte Firebase-App aus src/firebase.js.
 */

import { getAnalytics, setAnalyticsCollectionEnabled, logEvent as firebaseLogEvent } from 'firebase/analytics';
import { app } from '../firebase';
import { getConsent, onConsentChange } from './consent';

let analyticsInstance = null;

function getOrInitAnalytics() {
  if (!analyticsInstance) {
    analyticsInstance = getAnalytics(app);
  }
  return analyticsInstance;
}

/** Tracking einschalten (nach Consent) */
function enable() {
  const analytics = getOrInitAnalytics();
  setAnalyticsCollectionEnabled(analytics, true);
}

/** Tracking ausschalten (nach Widerruf) */
function disable() {
  if (analyticsInstance) {
    setAnalyticsCollectionEnabled(analyticsInstance, false);
  }
}

/** Initialisiert GA4 und hört auf spätere Consent-Änderungen */
export function initGA() {
  // Sofort aktivieren wenn Consent vorhanden
  if (getConsent() === 'granted') {
    enable();
  } else {
    // Sicherstellen dass Collection aus ist
    if (analyticsInstance) disable();
  }

  // Auf künftige Änderungen reagieren
  onConsentChange((value) => {
    if (value === 'granted') {
      enable();
    } else {
      disable();
    }
  });
}

/**
 * Event tracken — nur wenn Consent 'granted'.
 * Kann überall im Code importiert und genutzt werden.
 */
export function logEvent(eventName, params = {}) {
  if (getConsent() !== 'granted' || !analyticsInstance) return;
  firebaseLogEvent(analyticsInstance, eventName, params);
}

/** Page-View tracken (für SPA-Navigation) */
export function logPageView(pathname) {
  logEvent('page_view', {
    page_path: pathname,
    page_location: window.location.href,
  });
}
